export default __webpack_public_path__ + "img/favicon.d8498b68.ico";